import { IDropdownOption } from "@bps/fluent-ui";
import {
  DeviceCommand,
  TargetConfigurationType
} from "@libs/api/gateways/field/field-ops-gateway.dtos";

export interface BulkActionFormValuesBase {
  selectorId: string | undefined;
  actionType: BulkActionType;
}

export interface BulkAuthActionFormValues extends BulkActionFormValuesBase {
  authActionType: string | undefined;
}

export interface BulkSendCommandFormValues extends BulkActionFormValuesBase {
  smartDeviceCommandMessage?: DeviceCommand;
  configurationType: TargetConfigurationType;
}
export interface BulkAssignDeploymentRingFormValues
  extends BulkActionFormValuesBase {
  deploymentRingId: string | undefined;
  assignHighestPriority: boolean | undefined;
}

export interface AssignDeploymentRingFormValues {
  id: string;
  sortOrder: number;
}

export interface BulkAssignTenantDeploymentRingFormValues
  extends BulkActionFormValuesBase {
  clientDeploymentRings: AssignDeploymentRingFormValues[];
  serverDeploymentRings: AssignDeploymentRingFormValues[];
}

export enum BulkActionType {
  AuthAction = "AuthAction",
  SendCommand = "SendCommand",
  AssignDeploymentRing = "AssignDeploymentRing",
  UnassignDeploymentRing = "UnassignDeploymentRing",
  AssignTenantDeploymentRing = "AssignTenantDeploymentRing",
  UnassignTenantDeploymentRing = "UnassignTenantDeploymentRing"
}

export const ActionTypeOptions: IDropdownOption[] = [
  { key: BulkActionType.AuthAction, text: "Auth Action" },
  { key: BulkActionType.SendCommand, text: "Command" },
  {
    key: BulkActionType.AssignDeploymentRing,
    text: "Assign to Deployment Ring"
  },
  {
    key: BulkActionType.UnassignDeploymentRing,
    text: "Unassign from Deployment Ring"
  },
  {
    key: BulkActionType.AssignTenantDeploymentRing,
    text: "Assign to Tenant Deployment Ring"
  },
  {
    key: BulkActionType.UnassignTenantDeploymentRing,
    text: "Unassign from Tenant Deployment Ring"
  }
];
